import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { merge } from "lodash";
import "./Information.css";
import Loader from "react-loader-spinner";
import { Formik, Form } from "formik";
import { CountryDropdown } from "react-country-region-selector";
import { toast } from "react-toastify";

import Info from "../../../../assets/info.svg";
import {
  ButtonGroup,
  StyledBankTransferFormButton,
  colors,
} from "../../../../../../Syles/styles";
import { BankTranferDetailsTextInput } from "./../../../../../Formik/BankDetailsInput";
import closemodalicon from "../../../../../../Assets/closemodalicon.svg";
import { updateUserAction } from "../../../../../../../store/user/user.action";
import { useUser } from "../../../../../../../hooks/use-user";
import { $api } from "../../../../../../../helpers/$api";

const Information = ({ updateUser }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [states, setStates] = useState([]);
  const user = useUser();

  useEffect(() => {
    (async () => {
      try {
        const countries = await $api.user.getCountries();
        const userCountry = countries.find(
          (country) => country.name === user.country
        );
        if (userCountry) {
          const states = await $api.user.getStates(userCountry.id);

          setStates(states);
        }
      } catch (error) {
        // error
      }
    })();
  }, [setStates, user.country]);

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log(values);
    const update = merge({}, user, values);
    try {
      setSubmitting(true);
      await updateUser(update);
      toast.success("Update successfull");
    } catch (error) {
      toast.error(`error updating: ${error.message}`);
      // use toast or error reporting here
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="information">
      <div>
        <img
          src={Info}
          alt="Info"
          className="info-image"
          onClick={() => setShowSuccess(true)}
        />
      </div>
      <p className="information-para">Personal Information</p>
      <div className="formSection">
        <Formik
          initialValues={{
            gender: user.gender || "",
            state: user.state,
          }}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, values, handleChange }) => (
            <Form>
              <p className="info-label">First Name</p>
              <BankTranferDetailsTextInput
                name="firstname"
                type="tel"
                placeholder={user.firstname}
                disabled={true}
              />

              <p className="info-label">Last Name</p>
              <BankTranferDetailsTextInput
                name="lastname"
                type="tel"
                placeholder={user.lastname}
                disabled={true}
              />

              <p className="info-label">Username</p>
              <BankTranferDetailsTextInput
                name="username"
                type="tel"
                placeholder={user.username}
                disabled={true}
              />

              <p className="info-label">Gender</p>
              {/* <BankTranferDetailsTextInput
                name="gender"
                type="tel"
                placeholder={user.gender}
              /> */}
              <select
                name="gender"
                value={values.gender}
                id=""
                className="select-gender"
                onChange={handleChange}
                disabled={user.gender}
                style={{
                  outline: "none",
                }}
              >
                <option value=""> Select Gender</option>
                <option
                  value="male"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Male
                </option>
                <option
                  value="Female"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Female
                </option>
              </select>

              <p className="info-label">Email </p>
              <BankTranferDetailsTextInput
                name="email"
                type="tel"
                placeholder={user.email}
                disabled={true}
              />

              <p className="info-label">Phone Number</p>
              <BankTranferDetailsTextInput
                name="phonenumber"
                type="tel"
                placeholder={user.phone}
                disabled={true}
              />

              <p className="info-label">Country</p>
              <CountryDropdown
                style={{
                  width: "380px",
                  height: "48px",
                  borderRadius: "4px",
                  color: "#757575",
                  border: " 1px solid #c4c4c4",
                  fontSize: "12px",
                  display: "block",
                  outline: "none",
                  transition: "ease-in-out 0.3s",
                  margin: "12px auto 10px auto",
                  paddingLeft: "16px",
                  "&:focus": {
                    backgroundColor: "#fcf5f5",
                    color: "black",
                  },
                }}
                name="country"
                value={user.country}
                onChange={(_, e) => {}}
                disabled={true}
              />

              <p className="info-label">State</p>
              <select
                style={{
                  width: "380px",
                  height: "48px",
                  borderRadius: "4px",
                  color: "#757575",
                  border: " 1px solid #c4c4c4",
                  fontSize: "12px",
                  display: "block",
                  outline: "none",
                  transition: "ease-in-out 0.3s",
                  margin: "12px auto 10px auto",
                  paddingLeft: "16px",
                  "&:focus": {
                    backgroundColor: "#fcf5f5",
                    color: "black",
                  },
                }}
                name="state"
                value={values.state}
                onChange={handleChange}
                disabled={user.state}
              >
                <option value="" children="Select a state" />
                {states.map((state) => (
                  <option
                    key={state.id}
                    value={state.name}
                    children={state.name}
                  />
                ))}
              </select>

              <ButtonGroup className="button-group">
                {!isSubmitting && (
                  <StyledBankTransferFormButton type="submit">
                    Update Profile
                  </StyledBankTransferFormButton>
                )}

                {isSubmitting && (
                  <Loader
                    type="ThreeDots"
                    color={colors.primary}
                    height={49}
                    width={100}
                  />
                )}
              </ButtonGroup>
            </Form>
          )}
        </Formik>
      </div>

      <div
        className={`confirmbank__success-bg ${
          showSuccess ? "success-info" : ""
        }`}
      >
        <div className="confirm__success-content">
          <div className="confirm-close-modal">
            <button className="closemodal-btn">
              <img
                src={closemodalicon}
                alt=""
                className="closemodal"
                onClick={() => setShowSuccess(false)}
              />
            </button>
          </div>
          <div className="info-text">
            <h1>Kindly Note</h1>
            <p>
              Some details here can’t be edited. Contact hello@myovest.com to
              effect some changes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = { updateUser: updateUserAction };

export default connect(null, mapDispatchToProps)(Information);
